import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5.02A1.5 1.5 0 0 0 0 1.52v1.658a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V1.52a1.5 1.5 0 0 0-1.5-1.5zM0 7.416a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5v1.659a1.5 1.5 0 0 1-1.5 1.5H7.75v1.91H12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h4.25v-1.91H1.5a1.5 1.5 0 0 1-1.5-1.5zM4.706 2.35c0-.346.28-.625.625-.625h2a.625.625 0 0 1 0 1.25h-2a.625.625 0 0 1-.625-.625m.625 5.273a.625.625 0 1 0 0 1.25h2a.625.625 0 0 0 0-1.25zM1.629 2.349a.875.875 0 1 0 1.75 0 .875.875 0 0 0-1.75 0m0 5.898a.875.875 0 1 0 1.75 0 .875.875 0 0 0-1.75 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const programmingComputerDatabaseServer = { render };
export {
  programmingComputerDatabaseServer as default,
  render
};
//# sourceMappingURL=programming-computer-database-server.svg.js.map
